import { Serializable } from "./Serializable";

export class UserExperience implements Serializable<UserExperience> {
    sponsor: Sponser;
    features: Features;

    public getSelfAssign(selfAssign) {
        if (selfAssign == "PERSONAL_TEAM") {
            return this.sponsor.subjectId;
        }
    }

    deserialize(input): UserExperience {
        this.sponsor = new Sponser().deserialize(input.sponsor);
        this.features = new Features().deserialize(input.features);
        this.features.availableForms && (this.features.availableForms.selfAssignScope = this.getSelfAssign(this.features.availableForms.selfAssign));
        return this;
    }
}

export class Sponser implements Serializable<Sponser> {
    orgId: number;
    orgName: string;
    orgShortName: string;
    experienceName: string;
    subjectId?: number;
    deserialize(input): Sponser {
        this.orgId = input.orgId;
        this.orgName = input.orgName;
        this.orgShortName = input.orgShortName;
        this.experienceName = input.experienceName;
        this.subjectId = input.subjectId;
        return this;
    }
}

export class Features implements Serializable<Features> {
    availableForms?: AvailableForms;
    branding?: Branding;
    assignedForms?: AssignedForms;
    integration?: Integration;

    deserialize(input): Features {
        input.availableForms && (this.availableForms = new AvailableForms(input.availableForms.selfAssign, input.availableForms.assign));
        input.branding && (this.branding = new Branding(input.branding.logoStyle, input.branding.logoUrl));
        input.assignedForms && (this.assignedForms = new AssignedForms(input.assignedForms.shareMode));
        input.integration && (this.integration = new Integration(input.integration.azureCalendar, input.integration.zoom));
        return this;
    }
}

export class AvailableForms {
    selfAssign: string;
    assign: boolean;
    selfAssignScope?: number;


    constructor(selfAssign: string, assign: boolean) {
        this.selfAssign = selfAssign;
        this.assign = assign;
        this.selfAssignScope = null;
    }
}

export class Branding {
    logoStyle: string;
    logoUrl: string;

    constructor(logoStyle: string, logoUrl: string) {
        this.logoStyle = logoStyle;
        this.logoUrl = logoUrl;
    }
}


export class AssignedForms {
    shareMode: string;

    constructor(shareMode: string) {
        this.shareMode = shareMode;
    }
}

export class Integration {
    azureCalendar: boolean;
    zoom: boolean;

    constructor(azureCalendar: boolean, zoom: boolean) {
        this.azureCalendar = azureCalendar;
        this.zoom = zoom;
    }
}
